import { Injectable } from '@angular/core';
import { WrapperErrorListModel } from 'wrapper-error-list';
import { BehaviorSubject, filter } from 'rxjs';
import {
  passwordValidations,
  configs,
} from 'src/domains/site-managment/domains/system-config/domain/entity/configs-options.entity';
import { SystemConfigService } from 'src/domains/site-managment/domains/system-config/presenter/view/service/system-config.service';
@Injectable({
  providedIn: 'root',
})
export class CheckPasswordService {
  private static config = new BehaviorSubject<
    Map<passwordValidations, WrapperErrorListModel.validation>
  >(new Map());

  static get config$() {
    return this.config;
  }

  constructor(private systemConfigService: SystemConfigService) {
    this.systemConfigService.systemConfigs$
      .pipe(filter((value) => !!value))
      .subscribe((conditions) => this.checkValidations(conditions));
  }

  checkValidations(conditions: configs) {
    const nextConfigs = new Map<
      passwordValidations,
      WrapperErrorListModel.validation
    >();
    conditions.digit &&
      nextConfigs.set('digits', {
        validate: /\d/,
        text: `شامل اعداد باشد`,
      });
    conditions.lowercase &&
      nextConfigs.set('lowercase', {
        validate: /[a-z]/,
        text: `شامل حروف کوچک باشد. `,
      });
    conditions.uppercase &&
      nextConfigs.set('uppercase', {
        validate: /[A-Z]/,
        text: `شامل حروف بزرگ باشد`,
      });
    nextConfigs.set('minlength', {
      validate: new RegExp(`^.{${conditions.minLength},}$`),
      text: `حداقل دارای ${conditions.minLength}کاراکتر باشد`,
    });
    conditions.specialChar &&
      nextConfigs.set('symbols', {
        validate: /[!@#$%^&*(),.?":{}|<>]/,
        text: `شامل کاراکترهای خاص باشد`,
      });
    CheckPasswordService.config.next(nextConfigs);
  }
}
